export default {
  entity: "data_dictionary",
  title: "Data dictionary",
  headers: [
    {
      key: "expires",
      label: "Expires",
      type: "check",
      id: "expires",
    },
    {
      key: "days_to_expired",
      label: "Days to expire",
      type: "number",
      id: "days_to_expired",
      deps: ["expires"],
      resetValue: true,
      default: (item) => 0,
      readonly: (item) => !item.expires,
    },
  ],
}
